import React, { ChangeEvent, Component } from 'react';

import { debounce } from 'lodash';

import UiSearchInput from '../../../modules/ui/ui-search-input/ui-search-input';
const SEARCH_FILTER_PLACEHOLDER = 'Поиск по контрагентам';

const DEBOUNCE_TIMEOUT = 400;

interface IProps {
  isCredit?: boolean;
  onChange: (filters: Record<string, any>) => void;
}



class Filters extends Component<IProps> {
  debounceSearch: any;

  constructor(props: IProps) {
    super(props);

    this.debounceSearch = debounce(props.onChange, DEBOUNCE_TIMEOUT);
  }

  onQueryChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;
    this.debounceSearch({ search: value });
  };

  render() {
    return (
      <div className="history-tabs__filter">
        <div className="history-tabs__filter--288">
          <UiSearchInput
            sm
            // value={searchQuery}
            onChange={this.onQueryChange}
            placeholder={SEARCH_FILTER_PLACEHOLDER}
          />
        </div>
      </div>
    );
  }
}

export default Filters;
